// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__pmh4L","inputWrap":"styles_inputWrap__3djQJ","input":"styles_input__3IqGG"};